import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/verify-2.svg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "position-relative z-1" }
const _hoisted_4 = {
  href: "#",
  class: "d-block position-relative"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "position-absolute bottom-0 start-50 translate-middle-x w-100 p-2" }
const _hoisted_7 = {
  class: "rounded-3 p-3 d-flex justify-content-between align-items-center",
  style: {"background":"rgba(35, 39, 46, 0.7)","backdrop-filter":"blur(6px)"}
}
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "flex-shrink-0 position-relative" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-grow-1 ms-4 position-relative top-2" }
const _hoisted_12 = { class: "fs-14 fw-semibold mb-0 text-white" }
const _hoisted_13 = {
  class: "fs-12",
  style: {"color":"#b1bbc8"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-4 d-flex flex-wrap gap-2 justify-content-between align-items-center" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Top Collections"),
        _createElementVNode("a", {
          href: "#",
          class: "text-decoration-none text-primary fs-12"
        }, " View More ")
      ], -1)),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 25,
        centeredSlides: false,
        preventClicks: true,
        loop: false,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination-top-collections',
        },
        modules: _ctx.modules,
        class: "top-collections-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftItem, (nft) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: nft.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("a", _hoisted_4, [
                    _createElementVNode("img", {
                      src: nft.image,
                      class: "rounded-3",
                      alt: "collections"
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: nft.creator.image,
                            class: "rounded-circle",
                            style: {"width":"27px","height":"27px"},
                            alt: "user"
                          }, null, 8, _hoisted_10),
                          _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: _imports_0,
                            style: {"width":"15px"},
                            class: "position-absolute top-100 start-100 translate-middle",
                            alt: "verify"
                          }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("h4", _hoisted_12, _toDisplayString(nft.creator.name), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(nft.creator.items) + " Items ", 1)
                        ])
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("a", {
                        href: "#",
                        class: "d-inline-block text-secondary text-center rounded-circle text-decoration-none fs-16 hover-bg",
                        style: {"width":"30px","height":"30px","line-height":"30px","background-color":"#8695aa"}
                      }, [
                        _createElementVNode("i", { class: "ri-arrow-right-line" })
                      ], -1))
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "swiper-pagination-top-collections text-center mt-2" }, null, -1))
    ])
  ]))
}